<template>
  <div class="add-stop-view">
    <div class="flex flex-gap-1 justify-content-between align-items-center">
      <div class="left flex" :style="{ gap: 'var(--sp-1)' }">
        <PickupIcon v-if="stopType === ShipmentStopType.PICKUP" />
        <DropoffIcon v-else />

        {{ location?.locationName }}
      </div>

      <RygenButton
        v-if="removable"
        mode="tertiary"
        :icon="PrimeIcons.TRASH"
        :aria-label="t('common.removeParam', { param: location?.locationName })"
        :severity="Severity.DANGER"
        @click="emit('remove')"
      />
    </div>

    <div class="flex text-gray-darker" :style="{ gap: 'var(--sp-1)' }">
      <FontAwesomeIcon
        aria-hidden="true"
        :icon="['fas', 'external-link']"
        transform="shrink-2"
        class="opacity-0"
      />

      {{ location?.cityState }}
    </div>
  </div>
</template>

<script lang="ts" setup>
import { PrimeIcons } from '@primevue/core/api';
import type { PropType } from 'vue';
import { toRefs } from 'vue';
import { useI18n } from 'vue-i18n';

import { Severity } from '@rygen/rygen-ui/model';

import { EmbeddableLocation, ShipmentStopType } from '@/model';

import DropoffIcon from '@/components/shippingPoint/DropoffIcon.vue';
import PickupIcon from '@/components/shippingPoint/PickupIcon.vue';
import RygenButton from '@rygen/rygen-ui/components/button/RygenButton.vue';

const props = defineProps({
  location: {
    type: Object as PropType<EmbeddableLocation>,
    required: true,
  },
  stopType: {
    type: String as PropType<ShipmentStopType>,
    required: true,
  },
  removable: {
    type: Boolean,
    default: () => false,
  },
});
const { location, stopType, removable } = toRefs(props);
const emit = defineEmits<{
  (event: 'remove'): void;
}>();

const { t } = useI18n();
</script>

<style>
.add-stop-view {
  display: flex;
  flex-direction: column;
  gap: var(--sp-1);
}
</style>
